// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCsvX7RdDeDk_Pu7oF0iljd9drSgyM6r5M",
  authDomain: "note-react-e1434.firebaseapp.com",
  databaseURL: "https://note-react-e1434.firebaseio.com",
  projectId: "note-react-e1434",
  storageBucket: "note-react-e1434.appspot.com",
  messagingSenderId: "575571829147",
  appId: "1:575571829147:web:2a0c70aa0f5f2e1822013e"
};

export default firebaseConfig;
